import { z } from 'zod';
import { cursorPageQuerySchema } from './pagination.js';
/**
 * "Send feedback" (Profile → App section): a bug report or an idea, and what
 * an operator did about each.
 *
 * Its own file rather than folded into `foods.ts` or `users.ts`: this is a
 * genuinely new domain, not a filter preset over an existing endpoint the way
 * `food_requests` almost was — see that module's own note on when a new file
 * earns its `package.json` exports entry and contract-drift pair.
 */
export const FEEDBACK_KINDS = ['bug', 'idea'];
export const FEEDBACK_STATUSES = ['open', 'resolved', 'dismissed'];
export const adminFeedbackSchema = z.object({
    id: z.string().uuid(),
    kind: z.enum(FEEDBACK_KINDS),
    message: z.string(),
    status: z.enum(FEEDBACK_STATUSES),
    /** Who sent it. The console links it to the user detail screen. */
    userId: z.string().uuid(),
    displayName: z.string().nullable(),
    phone: z.string(),
    /** Self-reported at send time; null when the sender's "include app details" toggle was off. */
    appVersion: z.string().nullable(),
    devicePlatform: z.string().nullable(),
    deviceOsVersion: z.string().nullable(),
    /** An operator's note on how it was answered. Null while open. */
    adminNote: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const adminFeedbackListQuerySchema = cursorPageQuerySchema.extend({
    status: z.enum(FEEDBACK_STATUSES).optional(),
    kind: z.enum(FEEDBACK_KINDS).optional(),
});
export const adminFeedbackParamsSchema = z.object({ id: z.string().uuid() });
/** Answering, either way. The note is stored on the row, not only on the audit entry. */
export const adminFeedbackAnswerRequestSchema = z.object({
    note: z.string().trim().min(1).max(500).optional(),
});
//# sourceMappingURL=feedback.js.map